import { useCallback, useState } from "react";
import { RRule } from "rrule";
import { RepeatingIrrigationEvent } from "verdi-web-client/Models";

interface CreateZoneEventParams {
    zoneWateringPercentages: Record<string, number>;
    defaultDuration: number;
    rule: RRule | undefined;
    zoneIrrigationOffsets: Record<string, number> | undefined;
    options: Record<string, unknown> | undefined;
    startTime?: Date;
}

export const useCreateZoneEvent = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<Error | null>(null);

    const createZoneEvent = useCallback(async (createZoneEventParams: CreateZoneEventParams) => {
        setLoading(true);
        setError(null);
        try {
            // These created events will default to starting at the current time, and run only once
            const defaultRule = new RRule({
                freq: RRule.DAILY,
                dtstart: createZoneEventParams.startTime ?? new Date(),
                count: 1,
            });
            const event = await RepeatingIrrigationEvent.createNew(
                createZoneEventParams.zoneWateringPercentages,
                createZoneEventParams.defaultDuration,
                createZoneEventParams.rule ?? defaultRule,
                undefined,
                createZoneEventParams.zoneIrrigationOffsets,
                createZoneEventParams.options,
            );
            return event;
        } catch (errorEvent: unknown) {
            setError(errorEvent instanceof Error ? errorEvent : new Error(String(errorEvent)));
            return null;
        } finally {
            setLoading(false);
        }
    }, []);

    return {
        createZoneEvent,
        loading,
        error,
    };
};
